// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  baseUrl1: 'http://192.168.2.56:8000/',
  baseUrl3: 'http://192.168.2.83:8000/',
  baseUrl5: 'http://localhost:8000/',
  timeZone: 'America/Chicago',
  timechange: 10000,
  popupRefreshTime: 60000,

  popupWaitTime: 60000,
  drbintimechange: 60000,


  // baseUrl: 'https://api-asphalt-dev.livnsense.com/',
  baseUrl:'https://api-asphalt.livnsense.com/'
  // baseUrl:'http://192.168.2.54:8000/',
  // baseUrl: 'https://api-asphalt.livnsense.com/',

};
